import factory from '@atlassian/trello-error-ext';

export const AttachmentLimitExceededError = factory(
  'Attachment::LimitExceeded',
);
